'use client';

import { motion } from 'motion/react';
import type { ReactNode } from 'react';

import { useStickyHeaderAnimation } from './use-sticky-header-animation';

type StickyHeaderProps = {
    children: ReactNode;
};

export function MotionStickyHeader({ children }: StickyHeaderProps) {
    const style = useStickyHeaderAnimation();

    return (
        <motion.header className="header" style={style}>
            {children}
        </motion.header>
    );
}
